import React, { useState } from 'react';
import { generateMagicToken, storeMagicToken } from '../utils/authUtils';
import { ArrowRightIcon } from 'lucide-react';
interface LoginPageProps {
  onSendMagicLink: (email: string, token: string) => void;
}
const LoginPage: React.FC<LoginPageProps> = ({
  onSendMagicLink
}) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [magicLink, setMagicLink] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      alert('Please enter a valid email address');
      return;
    }
    setIsSubmitting(true);
    // Generate a magic link token
    const token = generateMagicToken();
    // Store the token
    storeMagicToken(email, token);
    // Simulate sending an email
    setTimeout(() => {
      setIsSubmitting(false);
      setEmailSent(true);
      // In a real app, this would be sent via email
      // For demo purposes, we'll just display it
      const magicLinkUrl = `${window.location.origin}/verify?token=${token}`;
      setMagicLink(magicLinkUrl);
      onSendMagicLink(email, token);
    }, 1500);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4" data-id="element-74">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8" data-id="element-75">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6" data-id="element-76">
          Route Optimizer Login
        </h1>
        {!emailSent ? <form onSubmit={handleSubmit} className="space-y-6" data-id="element-77">
            <div data-id="element-78">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-79">
                Email Address
              </label>
              <div className="relative" data-id="element-80">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-81">
                  <div className="h-5 w-5 text-gray-400" data-id="element-82" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="you@example.com" data-id="element-83" />
              </div>
            </div>
            <div data-id="element-84">
              <button type="submit" disabled={isSubmitting} className={`w-full flex justify-center items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-85">
                {isSubmitting ? <span data-id="element-86">Sending...</span> : <>
                    <span data-id="element-87">Send Magic Link</span>
                    <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-88" />
                  </>}
              </button>
            </div>
          </form> : <div className="space-y-6" data-id="element-89">
            <div className="bg-green-50 border border-green-200 rounded-md p-4" data-id="element-90">
              <div className="flex" data-id="element-91">
                <div className="flex-shrink-0" data-id="element-92">
                  <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-93">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-94" />
                  </svg>
                </div>
                <div className="ml-3" data-id="element-95">
                  <h3 className="text-sm font-medium text-green-800" data-id="element-96">
                    Magic link sent!
                  </h3>
                  <div className="mt-2 text-sm text-green-700" data-id="element-97">
                    <p data-id="element-98">
                      We've sent a magic link to {email}. Click the link to sign
                      in.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* For demo purposes only - in a real app this would be sent via email */}
            <div className="border border-gray-200 rounded-md p-4" data-id="element-99">
              <h3 className="text-sm font-medium text-gray-800 mb-2" data-id="element-100">
                Demo Magic Link
              </h3>
              <p className="text-xs text-gray-500 mb-2" data-id="element-101">
                (In a real app, this would be sent to your email)
              </p>
              <div className="bg-gray-100 p-2 rounded text-sm font-mono break-all" data-id="element-102">
                <a href={magicLink} className="text-blue-600 hover:underline" data-id="element-103">
                  {magicLink}
                </a>
              </div>
            </div>
            <button onClick={() => setEmailSent(false)} className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-104">
              Try a different email
            </button>
          </div>}
      </div>
    </div>;
};
export default LoginPage;